//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["rcp","bend_method","bend_ratio","bend_radius"],"CreateCorner",{R_:{bend:"Routing.BendCorner"}},4,0],[["rcp","bend_method","bend_ratio","bend_radius","bend_ratio_to_attribute","bend_attribute_name"],"CreateCornerFromAttribute",{R_:{bend:"Routing.BendCorner"}},6,0],[["rcp","bend_table"],"AssignCornerByBendTable",{R_:{new_crn:"Routing.BendCorner"}},2,0],[["bend_crn","bend_ratio"],"AssignCornerByBendRatio",{R_:{new_crn:"Routing.BendCorner"}},2,0],[["bend_crn","bend_ratio_to_attribute","bend_attribute_name"],"AssignCornerByBendRatioToAttribute",{R_:{new_crn:"Routing.BendCorner"}},3,0],[["bend_crn","bend_radius"],"AssignCornerByBendRadius",{R_:{new_crn:"Routing.BendCorner"}},2,0],[["segment"],"GetBendAssociatedToSegment",{R_:{corner:"Routing.BendCorner"}},1,0],[["objects","nCorners"],"GetBendCornersFromObjects",{R_:{corners:"Routing.BendCorner[]"}},1,0]],[]];
SPLM.Routing.BendCornerCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.BendCornerCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Routing.BendCornerCollection.Type = Object.freeze({
    "RadiusRatio" : "RadiusRatio", "Table" : "Table"});

export default SPLM;